import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPenToSquare } from '@fortawesome/free-solid-svg-icons'
import { float2moeda } from "../../../utils/Funcoes";
const ServicoList = ({ listServico, handleDelete, listPermissoes }) => {


    return (
        <>

            {listServico.map((item, key) => (
                <tr key={key}>
                    <td>{item.id}</td>
                    <td>{item.nome}</td>
                    <td>{float2moeda((item.valor))}</td>

                    <td className="text-center">
                        {(listPermissoes?.editar) ?
                            <Button size="sm" variant="primary" href={'/admin/configuracoes/servicos/cadEdit/' + item.id} title="Editar" className=""><FontAwesomeIcon icon={faPenToSquare} /></Button>
                            : ''}
                    </td>
                    <td className="text-center">
                        {(listPermissoes?.excluir) ?
                            <Button size="sm" variant="danger" title="Excluir" onClick={() => handleDelete(item.id)}><FontAwesomeIcon icon={faTrash} /></Button>
                            : ''}
                    </td>
                </tr>


            ))}
        </>
    )

}

export default ServicoList;